import instance from '@apis/instance';
import { SliceResponse } from '@models/page';
import {
  GetStampHistoriesParams, StampCardRow, StampCardSorter, StampHistoryRow,
} from '@models/stamp';

class StampApi {
  static getStampCards(sorter: StampCardSorter): Promise<StampCardRow[]> {
    return instance.get('/stamp-cards', { params: { sorter } });
  }

  static getStampHistories(
    shopId: string,
    params: GetStampHistoriesParams,
  ): Promise<SliceResponse<StampHistoryRow>> {
    return instance.get(`/stamp-card/${shopId}/history`, { params });
  }
}

export default StampApi;
